import { common } from './common'
import { promotions } from './promotionsUtil'
import { Icons } from './IconsUtil'
import { reduxUtil } from './reduxUtil'
import { dateUtil } from './dateUtil'
import { payload } from './payload'
import { filtersUtil } from './filterUtil'
import { pushNotificationUtil } from './pushNotificationUtil'
import { storesUtil } from './storesUtil'
import { JSUtility } from './JSUtility'
import { productsUtil } from './productsUtil'

export const util = {
    ...common,
    ...promotions,
    ...Icons(),
    ...reduxUtil,
    ...dateUtil,
    ...payload,
    ...filtersUtil,
    ...pushNotificationUtil,
    ...storesUtil,
    ...JSUtility,
    ...productsUtil,
}
